import script from "./WorkspaceChartPane.vue?vue&type=script&lang=js"
export * from "./WorkspaceChartPane.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__